import { Input } from "@/components/ui/input"

export function InputPreviewRoute(): JSX.Element {
  return (
    <div className="mx-auto max-w-4xl px-8.5 py-11">
      <header className="mb-8">
        <div className="font-id text-eyebrow uppercase tracking-[0.16em] text-text-3">
          Primitive
        </div>
        <h1 className="mt-1 text-display text-text">Input</h1>
      </header>

      <Section title="Default">
        <div className="w-72">
          <Input placeholder="Type something" />
        </div>
      </Section>

      <Section title="Disabled">
        <div className="w-72">
          <Input placeholder="Disabled" disabled />
        </div>
      </Section>

      <Section title="With error">
        <div className="w-72">
          <Input placeholder="65331-4" invalid defaultValue="bad-value" />
        </div>
      </Section>

      <Section title="With hint (via aria-describedby)">
        <div className="w-72 flex flex-col gap-1.5">
          <Input placeholder="Search rules" aria-describedby="input-hint" />
          <p id="input-hint" className="text-caption text-text-3">
            Case-insensitive. Matches id, text and KPI.
          </p>
        </div>
      </Section>

      <Section title="Sizes">
        <div className="w-72">
          <Input inputSize="sm" placeholder="Small" />
        </div>
        <div className="w-72">
          <Input inputSize="md" placeholder="Medium" />
        </div>
      </Section>
    </div>
  )
}

function Section({ title, children }: { title: string; children: React.ReactNode }): JSX.Element {
  return (
    <section className="mb-8">
      <h2 className="mb-3.5 font-id text-caption uppercase tracking-[0.16em] text-text-3">
        {title}
      </h2>
      <div className="flex flex-wrap items-center gap-3.5">{children}</div>
    </section>
  )
}
